'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _css = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css2 = require('antd/lib/radio/style/css');

var _radio = require('antd/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioButton = _radio2.default.Button;
var RadioGroup = _radio2.default.Group;
var Search = _input2.default.Search;

var TemplateFilter = _react2.default.createClass({
  displayName: 'TemplateFilter',

  propTypes: {
    status: _react.PropTypes.arrayOf(_react.PropTypes.object.isRequired).isRequired,
    types: _react.PropTypes.arrayOf(_react.PropTypes.object.isRequired).isRequired,
    filter: _react.PropTypes.object.isRequired,
    onChange: _react.PropTypes.func.isRequired
  },
  onStatusChange: function onStatusChange(e) {
    this.props.onChange('status', e.target.value);
  },
  onTypeChange: function onTypeChange(e) {
    this.props.onChange('type', e.target.value);
  },
  onKeywordChange: function onKeywordChange(keyword) {
    this.props.onChange('keyword', keyword);
  },
  render: function render() {
    return _react2.default.createElement(
      'div',
      { className: 'filter' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'label',
          null,
          '\u9002\u7528\u7C7B\u578B\uFF1A'
        ),
        _react2.default.createElement(
          RadioGroup,
          { onChange: this.onTypeChange, defaultValue: -1 },
          _react2.default.createElement(
            RadioButton,
            { value: -1 },
            '\u5168\u90E8'
          ),
          this.props.types.map(function (type) {
            return _react2.default.createElement(
              RadioButton,
              { key: type.id, value: type.id },
              type.name
            );
          })
        )
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'label',
          null,
          '\u6A21\u7248\u72B6\u6001\uFF1A'
        ),
        _react2.default.createElement(
          RadioGroup,
          { onChange: this.onStatusChange, defaultValue: -1 },
          _react2.default.createElement(
            RadioButton,
            { value: -1 },
            '\u5168\u90E8'
          ),
          this.props.status.map(function (status) {
            return _react2.default.createElement(
              RadioButton,
              { key: status.id, value: status.id },
              status.name
            );
          })
        )
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'label',
          null,
          '\u5173\u952E\u8BCD\uFF1A\xA0\xA0'
        ),
        _react2.default.createElement(Search, {
          placeholder: '\u6A21\u7248\u540D\u79F0\u7B49\uFF0C\u6309\u56DE\u8F66\u952E\u641C\u7D22',
          onSearch: this.onKeywordChange
        })
      )
    );
  }
});

exports.default = TemplateFilter;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/template_filter.js
// module id = 1339
// module chunks = 0